import Sheet from '../../shared/ui/Sheet';

// Condensed placeholders mirroring iOS TermsOfServiceView / PrivacyPolicyView /
// LiabilityDisclaimerView. Full legal text lives in the iOS app and at
// https://browne-ink.web.app.
const DOCS = {
  terms: {
    title: 'Terms of Service',
    sections: [
      {
        heading: 'Service',
        body: 'CheF SKN, operated by Browne Ink, connects independent delivery drivers with restaurants and customers in St. Kitts & Nevis. By using the driver portal you agree to these terms.',
      },
      {
        heading: 'Driver Responsibilities',
        body: 'Drivers are independent contractors responsible for maintaining a valid driver\'s license, vehicle registration, and insurance, and for complying with all traffic laws while performing deliveries. Drivers must also hold a valid Food Handler\'s Permit and submit a copy through the app for verification.',
      },
      {
        heading: 'Payments',
        body: 'Drivers earn a percentage of each delivery fee plus customer tips. Earnings are tracked in the app and paid out per the current payout schedule.',
      },
      {
        heading: 'Disputes',
        body: 'For any disputes, please contact our support team at +1 (869) 660-1052 or visit browne-ink.web.app.',
      },
    ],
  },
  privacy: {
    title: 'Privacy Policy',
    sections: [
      {
        heading: 'Data We Collect',
        body: 'We collect your name, contact details, vehicle information, profile photo, and real-time location while you are online so orders can be assigned and tracked.',
      },
      {
        heading: 'How We Use It',
        body: 'Your information is used to operate deliveries, display your status to restaurants and customers, calculate earnings, and send delivery notifications.',
      },
      {
        heading: 'Sharing',
        body: 'We share only what is needed to complete deliveries (e.g. your name, photo, vehicle, and live location with the customer whose order you are delivering). We do not sell your data.',
      },
      {
        heading: 'Contact',
        body: 'Questions about your data? Contact support at +1 (869) 660-1052.',
      },
    ],
  },
  liability: {
    title: 'Liability Waiver',
    sections: [
      {
        heading: 'Assumption of Risk',
        body: 'Delivery driving involves inherent risks including traffic accidents and road hazards. By going online you acknowledge and accept these risks.',
      },
      {
        heading: 'Independent Contractor',
        body: 'Drivers operate as independent contractors. You are responsible for your own vehicle, insurance, licensing, a valid Food Handler\'s Permit, and compliance with all applicable laws.',
      },
      {
        heading: 'Limitation of Liability',
        body: 'To the maximum extent permitted by law, CheF SKN and Browne Ink are not liable for accidents, injuries, or damages arising from delivery activities.',
      },
      {
        heading: 'Contact',
        body: 'Phone: +1 (869) 660-1052.',
      },
    ],
  },
};

export default function LegalSheet({ open, onClose, doc = 'terms' }) {
  const d = DOCS[doc] || DOCS.terms;
  return (
    <Sheet open={open} onClose={onClose} title={d.title}>
      <div className="px-4 pb-6 space-y-4">
        {d.sections.map(s => (
          <div key={s.heading}>
            <p className="text-sm font-bold text-gray-900">{s.heading}</p>
            <p className="text-sm text-gray-500 mt-1">{s.body}</p>
          </div>
        ))}
        <p className="text-xs text-gray-400 pt-2">
          Full legal text is available in the CheF SKN iOS app and at browne-ink.web.app.
        </p>
      </div>
    </Sheet>
  );
}
